import { useQuery } from '@tanstack/react-query';
import { Trip } from './useTrips';

const API_BASE = process.env.REACT_APP_API_BASE || '';

export interface SharedTrip extends Trip {
  token: string | null;
}

export function useSharedTrips() {
  return useQuery({
    queryKey: ['shared-trips'],
    queryFn: async () => {
      const response = await fetch(`${API_BASE}/api/users/me/shared`);
      if (!response.ok) throw new Error(`Server error: ${response.status}`);
      const body = (await response.json()) as { trips: SharedTrip[] };
      return body.trips;
    },
  });
}
